module.exports = __webpack_public_path__ + "static/media/paper-plane-solid.b55a8c7d.svg";